<div [formGroup]="activitiesForm"  [ngStyle]="{'margin-top':'40px'}" appAutoAudit [auditData]="fieldAuditData" [auditDisabled]="!!snapshotData">
    <div class="form-title-container">
        <h3>Actividades</h3>
        <a class="button add-button" *ngIf="!snapshotData" (click)="openActivityModal()">Añadir actividad</a>
    </div>

    <div class="card">
        <app-clients-table 
            [configTable]="activeTableConfig" 
            [snapshotMode]="!!snapshotData"
            (openItemEvent)="openActivityModal($event)" 
            (deleteItemEvent)="openDeleteActivityModal($event)">
        </app-clients-table>
    </div>

    <div class="modal" [ngClass]="{'is-active': isActivityModalVisible}">
        <div class="modal-background" (click)="closeActivityModal()"></div>
        <div class="modal-card">
            <header class="modal-card-head">
                <p class="modal-card-title">{{ snapshotData ? 'Ver actividad (histórico)' : editingActivityIndex !== undefined ? 'Editar actividad' : 'Nueva actividad' }}</p>
                <button class="delete" aria-label="close" (click)="closeActivityModal()"></button>
            </header>
            <form [formGroup]="activityForm" (submit)="saveActivity()">
            <section class="modal-card-body">
                    <div class="columns is-multiline">
                        <div class="column is-4 form-container">
                            <span class="label">Código CNAE</span>
                            <p-dropdown 
                                [options]="cnaeCodes"   
                                [filter]="true"
                                filterBy="code,title"
                                optionLabel="code" 
                                optionValue="code"
                                placeholder="Seleccionar código CNAE" 
                                formControlName="CNAECode"
                                emptyFilterMessage="No se encontraro resultados"
                                [appendTo]="'body'">
                                <ng-template let-option pTemplate="item">
                                    {{option.code}} - {{option.title}}
                                  </ng-template>
                                  <ng-template let-selected pTemplate="selectedItem">
                                    {{selected?.code}} - {{selected?.title}}
                                  </ng-template>
                            </p-dropdown>
                        </div>
                        <div class="column is-4 form-container">
                            <span class="label">Tipo de actividad</span>
                            <p-dropdown [options]="clientConstants.ACTIVITY_TYPES" optionLabel="label" optionValue="value" placeholder="Seleccionar tipo de actividad" formControlName="type" [appendTo]="'body'"/>
                        </div>
                        <div class="column is-4 form-container">
                            <span class="label">Código IAE</span>
                            <p-dropdown 
                                [options]="iaeCodesFiltered" 
                                [filter]="true"
                                filterBy="code,title"
                                optionLabel="code"
                                optionValue="code"
                                [group]="true"
                                optionGroupLabel="label"
                                optionGroupChildren="items"
                                placeholder="Seleccionar código IAE" 
                                formControlName="IAECode"
                                [showClear]="true"
                                emptyFilterMessage="No se encontraron resultados"
                                [appendTo]="'body'">
                                <ng-template let-group pTemplate="group">
                                    <div class="dropdown-group-header">
                                        <strong>{{group.label}}</strong>
                                    </div>
                                </ng-template>
                                <ng-template let-option pTemplate="item">
                                    {{option.code}} - {{option.title}}
                                </ng-template>
                                <ng-template let-value pTemplate="selectedItem">
                                    <ng-container *ngIf="value">
                                        <ng-container *ngIf="getSelectedIaeCode(value) as selectedCode">
                                            {{selectedCode.code}} - {{selectedCode.title}}
                                        </ng-container>
                                    </ng-container>
                                </ng-template>
                            </p-dropdown>
                        </div>
                        <div class="column is-4 form-container">
                            <span class="label">Fecha de alta</span>
                            <p-calendar [iconDisplay]="'input'" dateFormat="dd/mm/yy" dataType="date" [showIcon]="true" inputId="startDate" formControlName="startDate" [appendTo]="'body'"/>
                        </div>
                        <div class="column is-4 form-container">
                            <span class="label">Fecha de baja</span>
                            <p-calendar [iconDisplay]="'input'" dateFormat="dd/mm/yy" dataType="date" [showIcon]="true" inputId="endDate" formControlName="endDate" [appendTo]="'body'"/>
                        </div>
                        <div class="column is-4 field checkbox-field">
                            <p-checkbox formControlName="isPrincipal" binary="true" inputId="isPrincipal" />
                            <label for="isPrincipal">Actividad principal</label>
                        </div>
                        <div class="column is-12">
                            <h5 style="margin-top: 15px; margin-bottom: 0px; font-weight: 500;">Dirección</h5>
                        </div>
                        <div class="column is-4 form-container checkbox-field">
                            <p-checkbox formControlName="withLocal" binary="true" inputId="withLocal" />
                            <label for="withLocal">Con local</label>
                        </div>
                        <ng-container *ngIf="!activityForm.get('withLocal')?.value">
                        <div class="column is-4 form-container">
                            <span class="label">Municipio</span>
                            <input class="search-input" type="text" pInputText formControlName="town"/>
                        </div>
                        <div class="column is-4 form-container">
                            <span class="label">Provincia</span>
                            <input class="search-input" type="text" pInputText formControlName="province"/>

                        </div>
                        </ng-container>

                        <ng-container *ngIf="activityForm.get('withLocal')?.value">
                            <div class="column is-4 form-container">
                                <span class="label">Dirección</span>
                                <p-dropdown 
                                    [options]="addresses"
                                    optionLabel="acronym"
                                    optionValue="id"
                                    placeholder="Seleccionar dirección"
                                    formControlName="clientAddress">
                                    <ng-template let-address pTemplate="item">
                                        <span *ngIf="address.acronym">{{ address.acronym }} - </span>
                                        <span>{{ address.street }} {{ address.number }}, {{ address.town }}</span>
                                    </ng-template>
                                    <ng-template let-address pTemplate="selectedItem">
                                        <span *ngIf="address?.acronym">{{ address?.acronym }} - </span>
                                        <span>{{ address?.street }} {{ address?.number }}, {{ address?.town }}</span>
                                    </ng-template>
                                </p-dropdown>
                            </div>
                            <div class="column is-12">
                                <h5 style="margin-top: 15px; margin-bottom: 0px; font-weight: 500;">Superfície local</h5>
                            </div>
                            <div class="column is-4 form-container">
                                <span class="label">m² totales construidos</span>
                                <input class="search-input" type="number" pInputText formControlName="totalBuilt"/>
                            </div>
                            <div class="column is-4 form-container">
                                <span class="label">m² totales útiles</span>
                                <input class="search-input" type="number" pInputText formControlName="totalUseful"/>
                            </div>
                            <div class="column is-4 form-container">
                                <span class="label">m² sin reducción</span>
                                <input class="search-input" type="number" pInputText formControlName="m2WithoutReduction"/>
                            </div>
                            <div class="column is-4 form-container">
                                <span class="label">m² descubiertos</span>
                                <input class="search-input" type="number" pInputText formControlName="m2Uncovered"/>
                            </div>
                            <div class="column is-4 form-container">
                                <span class="label">m² enseñanza</span>
                                <input class="search-input" type="number" pInputText formControlName="m2Teaching"/>
                            </div>
                            <div class="column is-4 form-container">
                                <span class="label">m² almacén</span>
                                <input class="search-input" type="number" pInputText formControlName="m2Store"/>
                            </div>
                            <div class="column is-4 form-container">
                                <span class="label">m² aparcamiento cubierto</span>
                                <input class="search-input" type="number" pInputText formControlName="m2CoveredParking"/>
                            </div>

                            <div class="column is-4 form-container checkbox-field">
                                <p-checkbox formControlName="withWorkCenter" binary="true" inputId="withWorkCenter" />
                                <label for="withWorkCenter">Con centro de trabajo</label>
                            </div>
                            <ng-container *ngIf="activityForm.get('withWorkCenter')?.value">
                                <div class="column is-4 form-container">
                                    <span class="label">Código cuenta cotización pral en seguridad social</span>
                                    <input class="search-input" type="text" pInputText formControlName="socialSecurityCode"/>
                                </div>
                                <div class="column is-4 form-container">
                                    <span class="label">Código cuenta cotización del centro de trabajo</span>
                                    <input class="search-input" type="text" pInputText formControlName="workCenterCode"/>
                                </div>
                                <div class="column is-4 form-container">
                                    <span class="label">Código cuenta cotización becarios no remunerados</span>
                                    <input class="search-input" type="text" pInputText formControlName="internshipCode"/>
                                </div>
                                <div class="column is-4 form-container">
                                    <span class="label">Nº registro centro de trabajo autoridad laboral</span>
                                    <input class="search-input" type="text" pInputText formControlName="laboralAuthorityNumber"/>
                                </div>
                                <div class="column is-4 form-container">
                                    <span class="label">IBAN domiciliación nóminas</span>
                                    <p-dropdown
                                        [options]="bankAccounts"
                                        optionLabel="iban"
                                        optionValue="id"
                                        placeholder="Seleccionar cuenta bancaria"
                                        formControlName="payrollIban"
                                        [showClear]="true"
                                        [appendTo]="'body'"
                                        [emptyFilterMessage]="'No se encontraron resultados'">
                                        <ng-template let-account pTemplate="item">
                                            <span *ngIf="account.bankName">{{ account.bankName }} - </span>{{ account.iban | ibanFormat }}
                                        </ng-template>
                                        <ng-template let-account pTemplate="selectedItem">
                                            <span *ngIf="account?.bankName">{{ account?.bankName }} - </span>{{ account?.iban | ibanFormat }}
                                        </ng-template>
                                    </p-dropdown>
                                </div>
                                <div class="column is-4 form-container">
                                    <span class="label">IBAN seguros sociales</span>
                                    <p-dropdown
                                        [options]="bankAccounts"
                                        optionLabel="iban"
                                        optionValue="id"
                                        placeholder="Seleccionar cuenta bancaria"
                                        formControlName="socialSecurityIban"
                                        [showClear]="true"
                                        [appendTo]="'body'"
                                        [emptyFilterMessage]="'No se encontraron resultados'">
                                        <ng-template let-account pTemplate="item">
                                            <span *ngIf="account.bankName">{{ account.bankName }} - </span>{{ account.iban | ibanFormat }}
                                        </ng-template>
                                        <ng-template let-account pTemplate="selectedItem">
                                            <span *ngIf="account?.bankName">{{ account?.bankName }} - </span>{{ account?.iban | ibanFormat }}
                                        </ng-template>
                                    </p-dropdown>
                                </div>
                                <div class="column is-4 form-container">
                                    <span class="label">Mutua de accidentes y enfermedades profesionales</span>
                                    <input class="search-input" type="text" pInputText formControlName="accidentsMutua"/>
                                </div>
                                <div class="column is-4 form-container">
                                    <span class="label">Convenio colectivo aplicable</span>
                                    <input class="search-input" type="text" pInputText formControlName="collectiveAgreementApplicable"/>
                                </div>
                                <div class="column is-4 form-container">
                                    <span class="label">SPRL (Servicio prevencion riesgos laborales)</span>
                                    <input class="search-input" type="text" pInputText formControlName="srpl"/>
                                </div>
                                <div class="column is-4 form-container">
                                    <span class="label">Seguro de convenio</span>
                                    <input class="search-input" type="text" pInputText formControlName="agreementInsurance"/>
                                </div>
                                <div class="column is-4 form-container checkbox-field">
                                    <p-checkbox formControlName="legalRepresentation" binary="true" inputId="legalRepresentation" />
                                    <label for="legalRepresentation">Representación legal de los trabajadores</label>
                                </div>
                                <div class="column is-4 form-container">
                                    <span class="label">Tipo de representación legal</span>
                                    <p-dropdown [options]="clientConstants.LEGAL_REPRESENTATION_TYPES" optionLabel="label" optionValue="value" placeholder="Seleccionar tipo de representación legal" formControlName="legalRepresentationType" [appendTo]="'body'"/>
                                </div>
                                <div class="column is-4 form-container">
                                    <span class="label">Nº empresa TGSS (NET)</span>
                                    <input class="search-input" type="text" pInputText formControlName="tgssNumber"/>
                                </div>
                                <div class="column is-4 form-container checkbox-field">
                                    <p-checkbox formControlName="healthComittee" binary="true" inputId="healthComittee" />
                                    <label for="healthComittee">Comité de seguridad y salud</label>
                                </div>
                                <div class="column is-4 form-container checkbox-field">
                                    <p-checkbox formControlName="equalityPlan" binary="true" inputId="equalityPlan" />
                                    <label for="equalityPlan">Plan de igualdad</label>
                                </div>
                                <div class="column is-4 form-container checkbox-field">
                                    <p-checkbox formControlName="lismiObligations" binary="true" inputId="lismiObligations" />
                                    <label for="lismiObligations">Obligaciones LISMI</label>
                                </div>
                                <div class="column is-4 form-container checkbox-field">
                                    <p-checkbox formControlName="lgtbiProtocol" binary="true" inputId="lgtbiProtocol" />
                                    <label for="lgtbiProtocol">Protocolo prevención acoso personas LGTBI</label>
                                </div>
                                <div class="column is-4 form-container checkbox-field">
                                    <p-checkbox formControlName="complaintsChannel" binary="true" inputId="complaintsChannel" />
                                    <label for="complaintsChannel">Canal denuncias empresa</label>
                                </div>
                                <div class="column is-4 form-container checkbox-field">
                                    <p-checkbox formControlName="sexualProtocol" binary="true" inputId="sexualProtocol" />
                                    <label for="sexualProtocol">Protocolo prevención acoso sexual y laboral</label>
                                </div>
                                <div class="column is-4 form-container">
                                    <span class="label">Nº autorización sistema RED</span>
                                    <input class="search-input" type="text" pInputText formControlName="redSystemNumber"/>
                                </div>
                                <div class="column is-4 form-container">
                                    <span class="label">Régimen Seguridad Social</span>
                                    <input class="search-input" type="text" pInputText formControlName="socialSecurityRegime"/>
                                </div>
                            </ng-container>
                            </ng-container>


                        <!-- Campos exclusivos para Persona Jurídica -->
                        <ng-container *ngIf="clientType?.value === 'JURIDIC_PERSON'">
                            <div class="column is-12">
                                <h5 style="margin-top: 15px; margin-bottom: 0px; font-weight: 500;">Parámetros impuesto sobre actividades economicas (IAE)</h5>
                            </div>
                            <div class="column is-4 form-container">
                                <span class="label">Exención IAE</span>
                                <p-dropdown [options]="clientConstants.YES_NO_OPTIONS" optionLabel="label" optionValue="value" placeholder="Seleccionar" formControlName="iaeExcemption" [appendTo]="'body'"/>
                            </div>

                            <!-- Si tiene exención IAE -->
                            <ng-container *ngIf="activityForm.get('iaeExcemption')?.value === true">
                                <div class="column is-12">
                                </div>
                                <div class="column is-4 form-container checkbox-field">
                                    <p-checkbox formControlName="iaeExcemptionByStartUp" binary="true" inputId="iaeExcemptionByStartUp" />
                                    <label for="iaeExcemptionByStartUp">Exención por inicio</label>
                                </div>
                                <ng-container *ngIf="activityForm.get('iaeExcemptionByStartUp')?.value">
                                    <div class="column is-4 form-container">
                                        <span class="label">Fecha inicio exención</span>
                                        <p-calendar [iconDisplay]="'input'" dateFormat="dd/mm/yy" dataType="date" [showIcon]="true" inputId="iaeExcemptionStartDate" formControlName="iaeExcemptionStartDate" [appendTo]="'body'" [disabled]="true"/>
                                    </div>
                                    <div class="column is-4 form-container">
                                        <span class="label">Fecha baja exención</span>
                                        <p-calendar [iconDisplay]="'input'" dateFormat="dd/mm/yy" dataType="date" [showIcon]="true" inputId="iaeExcemptionEndDate" formControlName="iaeExcemptionEndDate" [appendTo]="'body'"/>
                                    </div>
                                </ng-container>

                                <div class="column is-12">
                                </div>
                                <div class="column is-4 form-container checkbox-field">
                                    <p-checkbox formControlName="iaeExcemptionByTurnover" binary="true" inputId="iaeExcemptionByTurnover" />
                                    <label for="iaeExcemptionByTurnover">Exención por cifra de negocios</label>
                                </div>
                                <ng-container *ngIf="activityForm.get('iaeExcemptionByTurnover')?.value">
                                    <div class="column is-4 form-container">
                                        <span class="label">Fecha inicio exención</span>
                                        <p-calendar [iconDisplay]="'input'" dateFormat="dd/mm/yy" dataType="date" [showIcon]="true" inputId="iaeExcemptionTurnoverStartDate" formControlName="iaeExcemptionTurnoverStartDate" [appendTo]="'body'" [disabled]="true"/>
                                    </div>
                                    <div class="column is-4 form-container">
                                        <span class="label">Fecha baja exención</span>
                                        <p-calendar [iconDisplay]="'input'" dateFormat="dd/mm/yy" dataType="date" [showIcon]="true" inputId="iaeExcemptionTurnoverEndDate" formControlName="iaeExcemptionTurnoverEndDate" [appendTo]="'body'"/>
                                    </div>
                                </ng-container>
                            </ng-container>

                            <!-- Si NO tiene exención IAE -->
                            <ng-container *ngIf="activityForm.get('iaeExcemption')?.value === false">
                                <div class="column is-4 form-container">
                                    <span class="label">Clase de cuota</span>
                                    <p-dropdown [options]="clientConstants.QUOTA_CLASS_TYPES" optionLabel="label" optionValue="value" placeholder="Seleccionar clase de cuota" formControlName="quotaClass" [appendTo]="'body'"/>
                                </div>
                                
                                <div class="column is-12">
                                    <h5 style="margin-top: 10px; margin-bottom: 5px; font-weight: 500;">Elementos</h5>
                                </div>
                                <div class="column is-4 form-container">
                                    <span class="label">Nº Obreros</span>
                                    <input class="search-input" type="number" pInputText formControlName="numWorkers"/>
                                </div>
                                <div class="column is-4 form-container">
                                    <span class="label">Potencia (KW)</span>
                                    <input class="search-input" type="number" step="0.01" pInputText formControlName="powerKw"/>
                                </div>
                                <div class="column is-4 form-container">
                                    <span class="label">Nº Vehículos</span>
                                    <input class="search-input" type="number" pInputText formControlName="numVehicles"/>
                                </div>
                                <div class="column is-4 form-container">
                                    <span class="label">Tipo de vehículos</span>
                                    <input class="search-input" type="text" pInputText formControlName="vehicleTypes"/>
                                </div>
                                <div class="column is-4 form-container">
                                    <span class="label">Nº Máquinas</span>
                                    <input class="search-input" type="number" pInputText formControlName="numMachines"/>
                                </div>
                                <div class="column is-4 form-container">
                                    <span class="label">Tipo de maquinaria</span>
                                    <input class="search-input" type="text" pInputText formControlName="machineryTypes"/>
                                </div>
                                <div class="column is-4 form-container">
                                    <span class="label">Escaparates</span>
                                    <input class="search-input" type="text" pInputText formControlName="shopWindows"/>
                                </div>
                            </ng-container>
                        </ng-container>
                    </div>
                    <div class="column is-12 form-container">
                        <span class="label">Observaciones</span>
                        <textarea class="search-input observations-field" pInputTextarea [autoResize]="true" formControlName="observations" rows="3" maxlength="2000"></textarea>
                    </div>
                </section>
                @if (activityForm.hasError('dateRange')) {
                  <p class="help is-danger" style="padding: 0 24px 12px;">La fecha de fin no puede ser anterior a la de inicio.</p>
                }
                @if (submitError) {
                  <p class="help is-danger" style="padding: 0 24px 12px;">{{ submitError }}</p>
                }
                <footer class="modal-card-foot buttons-container">
                    <ng-container *ngIf="snapshotData; else editButtons">
                        <button type="button" class="button cancel-button" (click)="closeActivityModal()">Cerrar</button>
                    </ng-container>
                    <ng-template #editButtons>
                        <button type="button" class="button cancel-button" (click)="closeActivityModal()">Cancelar</button>
                        <button class="button save-button" type="submit" [disabled]="!activityForm.valid">Guardar</button>
                    </ng-template>
                </footer>
            </form>
        </div>
    </div>

    <div class="delete-modal" [class.is-active]="isDeleteActivityModalVisible && !snapshotData">
        <div class="delete-modal-background" (click)="closeDeleteActivityModal()"></div>
            <div class="delete-modal-content">
                <h1 class="delete-modal-title">Eliminar actividad</h1>
                <div class="delete-modal-body">
                    <div class="column is-12">
                        <span>
                            ¿Está seguro/a que desea eliminar la actividad?
                        </span>
                    </div>
                    @if (submitError) {
                      <p class="help is-danger" style="padding: 0 24px 12px;">{{ submitError }}</p>
                    }
                    <div class="delete-modal-buttons">
                        <button class="button is-outlined cancel-button" (click)="closeDeleteActivityModal()">Cancelar</button>
                        <button class="comment-button button is-pulled-right" (click)="confirmDeleteActivity()" >Aceptar</button>      
                    </div>
                </div>             
            </div>
        </div>
</div>